import { useState } from "react";
import { Link } from "react-router";
import { MailCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Field, Input } from "@/components/ui/input";
import { AuthLayout } from "@/layouts/AuthLayout";
import { authClient } from "@/lib/auth-client";
import { t } from "@shared/i18n";

export function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    const { error } = await authClient.requestPasswordReset({ email, redirectTo: `${window.location.origin}/reset-password` });
    setLoading(false);
    if (error?.status === 429) return setError(t("Trop de demandes. Réessayez dans quelques minutes."));
    // Réponse identique que le compte existe ou non (pas d'énumération des comptes).
    setSent(true);
  };

  return (
    <AuthLayout
      title={t("Mot de passe oublié.")}
      subtitle={t("Indiquez votre adresse : nous vous enverrons un lien de réinitialisation valable une heure.")}
      footer={
        <Link to="/login" className="text-primary hover:underline">
          {t("Retour à la connexion")}
        </Link>
      }
    >
      {sent ? (
        <div className="glass-card p-5 text-sm">
          <MailCheck className="mb-3 size-6 text-primary" />
          {t("Si un compte existe pour")} <strong>{email}</strong>{t(", un e-mail vient d'être envoyé. Pensez à vérifier vos courriers indésirables.")}
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <Field label={t("Adresse e-mail")} error={error}>
            {(p) => <Input {...p} type="email" autoComplete="email" required value={email} onChange={(e) => setEmail(e.target.value)} />}
          </Field>
          <Button type="submit" size="lg" className="w-full" loading={loading}>
            {t("Envoyer le lien")}
          </Button>
        </form>
      )}
    </AuthLayout>
  );
}
